// Client-side NSFW content moderation.
//
// ─────────────────────────────────────────────────────────────────────────────
// DISABLED: the `nsfwjs` + `@tensorflow/tfjs` packages have been removed to cut
// the total build size (they are the heaviest deps in the tree). This module is
// now a pass-through stub: it keeps the exact same public API so every call site,
// prop, config value, and env var can stay in place unchanged. With the stub,
// `checkNSFWContent` always allows content and `loadNSFWModel` is a no-op.
//
// TO REVERT (re-enable moderation), do two things:
//   1. Reinstall the packages:
//        npm install nsfwjs@^4.2.1 @tensorflow/tfjs@^4.22.0
//   2. Replace the two stub functions below with the "ORIGINAL IMPLEMENTATION"
//      preserved at the bottom of this file (delete the stubs, uncomment the
//      original). Nothing else needs to change.
// ─────────────────────────────────────────────────────────────────────────────

// No-op: moderation is disabled, so there is no model to load.
export function loadNSFWModel() {
  return Promise.resolve(null);
}

// Pass-through: moderation is disabled, so nothing is ever flagged as NSFW.
export function checkNSFWContent(_blob) {
  return Promise.resolve(false);
}

// ─────────────────────────────────────────────────────────────────────────────
// ORIGINAL IMPLEMENTATION (re-enable on revert — see instructions above).
//
// Behavior is configurable via env vars:
//   REACT_APP_NSFW_CHECK_ENABLED — master switch (defaults to off).
//   REACT_APP_NSFW_THRESHOLD     — sum of Porn+Sexy+Hentai probabilities
//                                  above which the content is rejected.
//   REACT_APP_NSFW_FAIL_OPEN     — when true, classification failures
//                                  (model not loaded, image decode errors)
//                                  return false (allow). When false, they
//                                  return true (block).
//
// import { NSFW_CHECK_ENABLED, NSFW_THRESHOLD, NSFW_FAIL_OPEN } from '../config.js';
//
// let _nsfwModel = null;
// let _loadPromise = null;
//
// // Loads the NSFW.js model. Idempotent: subsequent calls return the same
// // promise, and once resolved the cached model is reused. Safe to call
// // eagerly at app startup; safe to call lazily on first use.
// export function loadNSFWModel() {
//   if (!NSFW_CHECK_ENABLED) {
//     return Promise.resolve(null);
//   }
//   if (_nsfwModel) {
//     return Promise.resolve(_nsfwModel);
//   }
//   if (_loadPromise) {
//     return _loadPromise;
//   }
//   // Load nsfwjs (and its TensorFlow.js dependency) on demand so this large
//   // library stays out of the initial bundle and is only downloaded when a
//   // check actually runs.
//   _loadPromise = import('nsfwjs')
//     .then(nsfwjs => nsfwjs.load("InceptionV3"))
//     .then(model => {
//       _nsfwModel = model;
//       console.log('NSFW model loaded.');
//       return model;
//     })
//     .catch(err => {
//       console.error('Failed to load NSFW model:', err);
//       _loadPromise = null;
//       return null;
//     });
//   return _loadPromise;
// }
//
// // Classifies the given image blob. Resolves to `true` if the image is
// // considered NSFW, `false` otherwise. Non-image blobs and decode failures
// // are governed by NSFW_FAIL_OPEN.
// //
// // The image is rendered to an offscreen canvas at its natural size before
// // being passed to the classifier; callers that pre-scale (e.g. via
// // `imageScaled`) avoid the cost of decoding very large originals.
// export function checkNSFWContent(blob) {
//   if (!NSFW_CHECK_ENABLED) {
//     return Promise.resolve(false);
//   }
//   if (!blob || (blob.type && !blob.type.startsWith('image/'))) {
//     // Not an image — nothing to classify.
//     return Promise.resolve(false);
//   }
//
//   return loadNSFWModel().then(model => {
//     if (!model) {
//       console.warn('NSFW model not available');
//       return !NSFW_FAIL_OPEN;
//     }
//
//     return new Promise(resolve => {
//       const img = new Image();
//       const canvas = document.createElement('canvas');
//       const ctx = canvas.getContext('2d');
//       const objectUrl = URL.createObjectURL(blob);
//
//       const cleanup = () => URL.revokeObjectURL(objectUrl);
//
//       img.onload = async () => {
//         try {
//           canvas.width = img.naturalWidth || img.width;
//           canvas.height = img.naturalHeight || img.height;
//           ctx.drawImage(img, 0, 0);
//
//           const predictions = await model.classify(canvas);
//           const nsfwScore   = predictions.find(p => p.className === 'Porn')?.probability || 0;
//           const sexyScore   = predictions.find(p => p.className === 'Sexy')?.probability || 0;
//           const hentaiScore = predictions.find(p => p.className === 'Hentai')?.probability || 0;
//
//           const isNSFW = (nsfwScore + sexyScore + hentaiScore) > NSFW_THRESHOLD;
//           console.log(`NSFW ${isNSFW ? 'content detected' : 'check passed'}:`,
//             { nsfwScore, sexyScore, hentaiScore, threshold: NSFW_THRESHOLD });
//           resolve(isNSFW);
//         } catch (error) {
//           console.error('NSFW classification failed:', error);
//           resolve(!NSFW_FAIL_OPEN);
//         } finally {
//           cleanup();
//         }
//       };
//
//       img.onerror = () => {
//         console.error('Failed to load image for NSFW check');
//         cleanup();
//         resolve(!NSFW_FAIL_OPEN);
//       };
//
//       img.src = objectUrl;
//     });
//   });
// }
